/**
 * @name fireClickEvent
 * @param element
 * @description this function can fire onclick handler for any DOM-Element
 */
const fireClickEvent = (element) => {
  const evt = new window.MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true,
  });
  return element.dispatchEvent(evt);
};

/**
 * @name openNewURLInTheSameWindow
 * @param targetURL
 * @description this function will setup a virtual anchor element
 * and fire click handler to open new URL in the same room
 * it works better than location.href=something or location.reload()
 */
export const openNewURLInTheSameWindow = (targetURL) => {
  const a = document.createElement('a');
  a.href = targetURL;
  return fireClickEvent(a);
};

/**
 * @name openNewTabOrNewWindow
 * @param targetURL
 * @description this function will setup a virtual anchor element
 * and fire click handler to open new URL in other room
 * it works better than location.href=something or location.reload()
 */
export const openNewTabOrNewWindow = (targetURL) => {
  const a = document.createElement('a');
  a.href = targetURL;
  a.target = '_blank'; // now it will open new tab/window and bypass any popup blocker!
  return fireClickEvent(a);
};
